export default __webpack_public_path__ + "static/mbrunette-2cd76e12f77f5d027d4dfbe2964b77bf.jpg";